import type { routes } from '@semios/app-platform-banyan-route-definitions'
import type { TAggregationInterval } from '@semios/app-platform-value-type-definitions'
import type { TEmitterType } from '@semios/app-platform-values-helpers-and-types'
import {
  getValueTypeFromEmitterType,
  IRRIGATION_PRESSURE_VALUE_TYPE_PREFIX,
} from '@semios/app-platform-values-helpers-and-types'
import type { TSelectedFieldAssetsStoreState } from 'stores/selectedFieldAssetsStore/selectedFieldAssetsStore'
import type { selectedValueGroupsStore } from 'stores/selectedValueGroupsStore/selectedValueGroupsStore'
import { getPointLngLatsForIrrigationEmitterZoneId } from 'utils/getPointLngLatsForIrrigationEmitterZoneId'

export const getPressureSensorArgs = ({
  selectedValueGroups,
  selectedFieldAssets,
  emitterType,
  valueTypeForIntervals,
  intervalToRequest,
}: {
  selectedValueGroups: ReturnType<typeof selectedValueGroupsStore.getState>['selectedValueGroups']
  selectedFieldAssets: TSelectedFieldAssetsStoreState
  emitterType: TEmitterType
  valueTypeForIntervals: string
  intervalToRequest: TAggregationInterval
}): Partial<routes.Values.Request> => {
  if (!selectedValueGroups.irrigation_activity_pressure || !selectedFieldAssets.irrigationZoneEmitter)
    return {}

  const preferredAggregationInterval = {
    preferredAggregationInterval: intervalToRequest,
  }

  const valuesRequestedForPoints: Record<string, typeof preferredAggregationInterval> = {}

  valuesRequestedForPoints[valueTypeForIntervals] = preferredAggregationInterval

  if (intervalToRequest !== 'DAILY') {
    const valueTypeForPressure = getValueTypeFromEmitterType(
      IRRIGATION_PRESSURE_VALUE_TYPE_PREFIX,
      emitterType,
    )

    valuesRequestedForPoints[valueTypeForPressure] = preferredAggregationInterval
  }

  const lngLatsForZone = getPointLngLatsForIrrigationEmitterZoneId({
    propertyId: Number(selectedFieldAssets.property),
    irrigationEmitterZoneId: selectedFieldAssets.irrigationZoneEmitter,
  })

  if (lngLatsForZone.length === 0) return {}

  return {
    points: {
      lngLats: lngLatsForZone,
      valuesRequested: valuesRequestedForPoints,
    },
  }
}
